/*
 * Hand chain waitlist (collection section kardima-waitlist-signup + product snippet
 * kardima-waitlist-pdp). Same mechanism as assets/kardima-guide-signup.js: posts the email
 * straight to Klaviyo's client subscriptions API and loads nothing else (no klaviyo.js, no
 * cookie), so it works whatever the visitor chose in the cookie banner.
 *
 * Profile properties come from data-props (JSON), e.g. {"kilde":"venteliste-handkjede",
 * "onsket_design":"lykke-handkjede-klover","onsker":"solv"}, so Klaviyo can segment per design.
 * A [data-waitlist-toggle] button (product page) reveals its form and hides itself.
 * List and company IDs and every message come from data attributes; this file has no copy.
 */
(function () {
  'use strict';

  var ENDPOINT = 'https://a.klaviyo.com/client/subscriptions';
  var REVISION = '2024-10-15';
  var EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

  function setup(form) {
    var input = form.querySelector('input[type="email"]');
    var button = form.querySelector('button[type="submit"]');
    var status = form.querySelector('[data-signup-status]');
    if (!input || !button || !status) return;

    var company = form.getAttribute('data-company') || '';
    var list = form.getAttribute('data-list') || '';
    var source = form.getAttribute('data-source') || 'venteliste-handkjede';
    var props = {};
    try { props = JSON.parse(form.getAttribute('data-props') || '{}'); } catch (e) { props = {}; }

    function say(kind, text) {
      status.textContent = text || '';
      status.setAttribute('data-kind', kind);
      status.hidden = !text;
    }

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      if (form.classList.contains('is-pending')) return;

      var email = (input.value || '').trim();
      if (!EMAIL_PATTERN.test(email)) {
        say('invalid', form.getAttribute('data-msg-invalid'));
        input.focus();
        return;
      }
      if (!company || !list) {
        say('error', form.getAttribute('data-msg-error'));
        return;
      }

      form.classList.add('is-pending');
      button.disabled = true;
      say('', '');

      var body = {
        data: {
          type: 'subscription',
          attributes: {
            custom_source: source,
            profile: { data: { type: 'profile', attributes: { email: email, properties: props } } }
          },
          relationships: { list: { data: { type: 'list', id: list } } }
        }
      };

      fetch(ENDPOINT + '?company_id=' + encodeURIComponent(company), {
        method: 'POST',
        headers: { 'Content-Type': 'application/vnd.api+json', 'revision': REVISION },
        body: JSON.stringify(body)
      })
        .then(function (response) {
          if (response.status === 202 || response.ok) {
            input.value = '';
            form.classList.add('is-done');
            say('success', form.getAttribute('data-msg-success'));
            return;
          }
          throw new Error('klaviyo ' + response.status);
        })
        .catch(function () { say('error', form.getAttribute('data-msg-error')); })
        .then(function () {
          form.classList.remove('is-pending');
          button.disabled = false;
        });
    });
  }

  function init() {
    var forms = document.querySelectorAll('[data-kardima-waitlist]');
    for (var i = 0; i < forms.length; i += 1) setup(forms[i]);
    var toggles = document.querySelectorAll('[data-waitlist-toggle]');
    for (var j = 0; j < toggles.length; j += 1) {
      toggles[j].addEventListener('click', function (event) {
        var target = document.getElementById(event.currentTarget.getAttribute('aria-controls'));
        if (!target) return;
        target.hidden = false;
        event.currentTarget.setAttribute('aria-expanded', 'true');
        event.currentTarget.hidden = true;
        var field = target.querySelector('input[type="email"]');
        if (field) field.focus();
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
